import { render, staticRenderFns } from "./ArticleCheckFailureMessage.vue?vue&type=template&id=4b62b152&scoped=true"
import script from "./ArticleCheckFailureMessage.vue?vue&type=script&lang=ts"
export * from "./ArticleCheckFailureMessage.vue?vue&type=script&lang=ts"
import style0 from "./ArticleCheckFailureMessage.vue?vue&type=style&index=0&id=4b62b152&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b62b152",
  null
  
)

export default component.exports